import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components/ensigns';
import { SpecraInlineBanner, SpecraPopover } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
/** WRT-08: tracked changes (e.g. from Assist) waiting for review in the editor. */ export function PendingChangesBanner({ authors, count }) {
    const [anchor, setAnchor] = useState(null);
    const [open, setOpen] = useState(false);
    if (count <= 0) return null;
    const by = authors?.length ? ` (${authors.join(', ')})` : '';
    return /*#__PURE__*/ _jsx(SpecraInlineBanner, {
        action: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(SpecraButton, {
                    "data-testid": Testids.officeWorkspace.pendingHowTo,
                    onClick: ()=>setOpen((o)=>!o),
                    ref: setAnchor,
                    size: "sm",
                    variant: "secondary",
                    children: "How to review"
                }),
                /*#__PURE__*/ _jsx(SpecraPopover, {
                    anchor: anchor,
                    "aria-label": "How to review tracked changes",
                    onOpenChange: setOpen,
                    open: open,
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "w-64 text-[length:var(--fs-ui-caption)]",
                        children: "Open the Review tab in the editor toolbar, then Accept or Reject each change, or use Accept all."
                    })
                })
            ]
        }),
        "data-testid": Testids.officeWorkspace.pendingChanges,
        tone: "info",
        variant: "framed",
        children: count === 1 ? `1 tracked change is waiting for review${by}` : `${count} tracked changes are waiting for review${by}`
    });
}
